import VExpansionPanel from './VExpansionPanel'
import VExpansionPanelContent from './VExpansionPanelContent'

export default {
  VExpansionPanel,
  VExpansionPanelContent
}



// WEBPACK FOOTER //
// ./src/components/expansion-panel/index.js